// Generated from Figma Design Guidelines

export const ProductLineText2Image = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.667 3.25049C19.2903 3.25049 21.417 5.37714 21.417 8.00049V12.0005C21.417 12.4147 21.0812 12.7505 20.667 12.7505C20.253 12.7502 19.917 12.4146 19.917 12.0005V8.00049C19.917 6.20556 18.4619 4.75049 16.667 4.75049H7.33398C5.53911 4.75055 4.08398 6.2056 4.08398 8.00049V11.1509C6.07002 10.9723 8.48263 11.2421 10.5225 12.3403C12.93 13.6367 14.7509 16.0557 14.751 20.0005C14.751 20.4146 14.415 20.7503 14.001 20.7505C13.9782 20.7505 13.9558 20.7486 13.9336 20.7466C13.9117 20.7485 13.8896 20.7505 13.8672 20.7505H7.33398C4.71069 20.7504 2.58398 18.6238 2.58398 16.0005V8.00049C2.58398 5.37717 4.71069 3.25055 7.33398 3.25049H16.667ZM9.81152 13.6606C8.04138 12.7077 5.86897 12.4741 4.08398 12.6577V16.0005C4.08398 17.7954 5.53911 19.2504 7.33398 19.2505H13.2236C13.0161 16.3253 11.5903 14.6185 9.81152 13.6606Z"
      fill="currentColor"
    />
    <circle cx="15.5996" cy="9.06641" r="1.75" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M19.0012 15.2563V20.0724M17.7891 20.2903C18.7358 20.2903 20.2133 20.2903 20.2133 20.2903"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0918 16.0119V15.1634C16.0918 14.9626 16.2546 14.7998 16.4554 14.7998H21.5463C21.7472 14.7998 21.91 14.9626 21.91 15.1634V16.0119"
      stroke="currentColor"
      strokeWidth="1.1"
    />
  </svg>
);
